import { ReactNode } from 'react';
import { Drawer, Typography, IconButton, Box, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ellipsisStyle } from '../utils/style.utils';

export interface SheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  width?: number;
  showCloseButton?: boolean;
  titleIcon?: ReactNode;
  keepMounted ?: boolean;
}

export default function Sheet({ open, onClose, title, children, width = 480, keepMounted, showCloseButton = true, titleIcon }: SheetProps): React.JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      keepMounted={keepMounted}
      slotProps={{
        paper: {
          sx: {
            width: {
              xs: undefined,
              md: width,
            },
            padding: 2,
            margin: 1,
            height: {
              xs: undefined,
              sm: 'calc(100% - 48px)',
            },
            maxHeight: {
              xs: 'calc(100vh - 80px)',
              sm: 'calc(100vh - 48px)',
            },
            borderRadius: 6,
            backgroundColor: 'surfaceContainerLow.main',
            overflowX: 'hidden',
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ...ellipsisStyle }}>
          {titleIcon}
          <Typography sx={ellipsisStyle} variant="titleLarge">
            {title}
          </Typography>
        </Box>
        {showCloseButton && (
          <IconButton onClick={onClose} size="large">
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      {children}
    </Drawer>
  );
}
